import React from 'react';
import styled from 'styled-components';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IconName, library} from '@fortawesome/fontawesome-svg-core';
import {fab} from '@fortawesome/free-brands-svg-icons';
import {faMapLocation, faEnvelope} from '@fortawesome/free-solid-svg-icons';

import {ContainerLg} from '../components';
import CONTENT from '../content';
import {Link} from 'gatsby';

library.add(fab);

const StyledFooter = styled.footer.attrs({
  className: 'site-footer'
})`
  width: 100%;
  min-height: 475px;
  color: #fff;
  background-image: url('/images/footer-stickers.jpeg');
  .container-lg {
  }
  .footer_top {
    padding: 75px 0 40px;
    display: flex;
    flex-direction: row;
    .left-half {
      display: flex;
      flex-direction: column;
      .footer-image {
        margin-bottom: 2rem;
      }
      .footer-info {
        color: #fff;
        gap: 8px;
        align-items: center;
        display: flex;
        svg {
          color: #f6df19;
        }
        &:hover {
          color: #fcc100;
          cursor: pointer;
        }
      }
    }
    .right-half {
      margin-left: auto;
      width: 240px;

      label {
        font-size: 1.2rem;
        font-weight: 600;
      }
    }
  }
  .footer_bottom {
    .footer_social {
      display: flex;
      justify-content: center;
      gap: 16px;
      border-top: 1px dashed #eee;
      padding-top: 35px;
      margin: 0 auto;

      .social-button {
        background: #f6df19;
        color: #212121;
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border-radius: 100%;
        display: block;
        &:hover {
          background: #fcc100;
          color: #212121;
        }
      }
    }
    .footer_copywrite {
      text-align: center;
      margin-bottom: 25px;
      padding-top: 25px;
      color: #fff;
    }
  }
`;

const Footer = () => (
  <StyledFooter>
    <ContainerLg>
      <div className="footer_top">
        <div className="left-half">
          <div className="footer-image">
            <img src={CONTENT.LOGO.black} height="30px" alt="logo" />
          </div>

          <a
            className="footer-info"
            href="https://www.google.com/maps/place/CineStar+Novi+Sad+4DX+(BIG+Shopping+center)/@45.2748093,19.8285926,15z/data=!4m2!3m1!1s0x0:0x207f3d36d1de004c?sa=X&ved=2ahUKEwihk7uo_Jb4AhWw8rsIHWGkBJcQ_BJ6BAhEEAU"
            target="_blank"
          >
            <FontAwesomeIcon icon={faMapLocation} title="Location" />
            {CONTENT.FOOTER.location}
          </a>
          <a className="footer-info" href={`mailto:${CONTENT.FOOTER.contactEmail}`}>
            <FontAwesomeIcon icon={faEnvelope} title="Contact email" />
            {CONTENT.FOOTER.contactEmail}
          </a>
        </div>
        <div className="right-half">
          <label>Subscribe</label>
          <p>
            We would love to share awesome opportunities to help us send you latest of our info.
          </p>
          <p>
            Subscribe <a href="http://eepurl.com/gnVWPH">HERE!</a>
          </p>
        </div>
      </div>
      <div className="footer_bottom">
        <div className="footer_social">
          {CONTENT.SOCIAL_URLS.map((item, index) => {
            return (
              <a key={index} href={item.url} target="_blank" className="social-button ">
                <FontAwesomeIcon icon={['fab', item.icon as IconName]} title={item.name} />
              </a>
            );
          })}
        </div>

        <div className="footer_copywrite">
          <div className="footer_terms">
            <Link to="/terms-of-use-and-sale">Terms and Conditions / </Link>
            <Link to="/privacy-policy">Privacy Policy / </Link>
            <Link to="/return-policy">Return Policy</Link>
          </div>
          <p>{CONTENT.FOOTER.copywrite}</p>
        </div>
      </div>
    </ContainerLg>
  </StyledFooter>
);

export default Footer;
